import axios, { AxiosHeaders } from 'axios';
export default function useAxios() {
    const instance = axios.create({
        // baseURL: 'http://192.168.6.139:8000',
        baseURL: window.APP_CONFIG.VITE_API_BASE_URL,
        timeout: 5000,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('Authorization') || ''
        }
    });
    instance.interceptors.request.use((config) => {
        const token = localStorage.getItem('Authorization');
        if (token) {
            if (config.headers instanceof AxiosHeaders) {
                config.headers.set('Authorization', token);
            }
            else {
                config.headers = new AxiosHeaders({
                    Authorization: token
                });
            }
        }
        return config;
    }, error => {
        return Promise.reject(error);
    });
    async function get(url, params = {}) {
        try {
            const response = await instance.get(url, { params });
            return response.data;
        }
        catch (error) {
            throw new Error(error.response?.data?.message || error.message);
        }
    }
    async function post(url, data = {}, params = {}) {
        try {
            const response = await instance.post(url, data, { params });
            return response.data;
        }
        catch (error) {
            throw new Error(error.response?.data?.message || error.message);
        }
    }
    return {
        instance,
        get,
        post
    };
}
